import {
  getWlPatientsApi,
  getWlVisitsApi,
  getWlAppointmentsApi,
  getWlReportsApi,
  isInsuranceLane,
} from '@/core/services/api/weightloss-inventory/laneApi'

/** Expone programContext y APIs del carril actual (regular | insurance). */
export default {
  computed: {
    programContext() {
      const path = (this.$route && this.$route.path) || ''
      if (path.startsWith('/insurance-weightloss')) return 'insurance'
      const fromMeta =
        this.$route &&
        this.$route.matched &&
        [...this.$route.matched]
          .reverse()
          .map(r => r.meta && r.meta.programContext)
          .find(Boolean)
      return fromMeta || (this.$route && this.$route.meta && this.$route.meta.programContext) || 'normal'
    },
    isInsuranceLane() {
      return isInsuranceLane(this.programContext)
    },
    wlPatientsApi() {
      return getWlPatientsApi(this.programContext)
    },
    wlVisitsApi() {
      return getWlVisitsApi(this.programContext)
    },
    wlAppointmentsApi() {
      return getWlAppointmentsApi(this.programContext)
    },
    wlReportsApi() {
      return getWlReportsApi(this.programContext)
    },
  },
}
